import { render, staticRenderFns } from "./5.vue?vue&type=template&id=0bfdcc22&scoped=true"
var script = {}
import style0 from "./5.vue?vue&type=style&index=0&id=0bfdcc22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfdcc22",
  null
  
)

export default component.exports